import { Deduction } from '@models/payroll/deduction.model';

export class CompanyDeduction extends Deduction {}
